import React, { Component } from 'react';
import {Card,Spin } from 'antd'
//import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import './login.css'
import '../iconfont.css'
import WS from '../../components/websocket'
import {IsPC,isWeChat} from "../../components/IsPc";
import {GetUrlParam3} from "../../components/getUrlParam3";
import Axios from '../../components/request/axios'
import Base64 from "../../components/base64";
///todo：配置登录二维码的回调地址
//const baseUrl='http://localhost:3000/#/';
//const baseUrl='http://ticks.precisiongenes.com.cn/#/';
const style1={
    transform: 'rotateY(0deg)'
};
const style2={
    transform: 'rotateY(180deg)'
};
const style11={
    transform: 'rotateY(0deg)',
    transition: 'all 0.8s'
};
const style22={
    transform: 'rotateY(180deg)',
    transition: 'all 0.8s'
};

class Login extends Component {
    state={
        index:0,
        hasUser:true, ///默认有账号
        spinning:false
    };
    componentDidMount() {
        WS('login');//连接websocket
        this.toreLoadWxlogin('parent');///默认家长端
        console.log(isWeChat());
        let code=GetUrlParam3('code');
        let state=GetUrlParam3('state');
        if(code&&state){
            console.log('获取到了code');
            Axios.post('/api/v1/wechat-official-login/',{code:code}).then((res)=>{
                if(res&&res.success){
                  if(res.code===2004){//已经注册
                      this.setState({
                          spinning:true
                      });
                      let values={
                          username:'',
                          password:''
                      };
                      if(res.data.length===1){
                          values={
                              username:res.data[0].username,
                              password:res.data[0].union_id
                          };
                      }else {
                          for(let i=0;i<res.data.length;i++){
                              if(res.data[i].username.match('doctor')){///优先医生账号登录
                                  values={
                                      username:res.data[i].username,
                                      password:res.data[i].union_id
                                  };
                                  break;
                              }
                          }
                      }
                      Axios.post('/api/v1/token-auth/',values).then((response) => {
                          if (response){
                              let token=response.token;
                              let nowTimeStamp=(new Date()).valueOf();
                              window.localStorage.setItem('token',token+"&&"+nowTimeStamp);
                              let token1=token.split(".");
                              let info=Base64.decode(token1[1]);//获取token里的部分用户信息
                              let userId=info.split(',')[0].split(':')[1];//用户id
                              window.sessionStorage.setItem("current","index_#/");///默认为首页
                              Axios.get('/api/v1/users/'+userId+'/').then((res)=>{
                                  //console.log(res);
                                  window.localStorage.setItem('userInfo',JSON.stringify(res));
                                  setTimeout(()=>{///延迟清除websocket
                                      window.client.disconnect(function() {
                                          console.log('清除成功！');
                                      });
                                  },2000);
                                  window.parent.location.hash='#/';
                              });
                          }
                      });
                  }
                  if(res.code===2003){//已经注册
                     this.setState({
                         hasUser:false
                     })
                  }
                }
            })
        }
       /* Axios.post('/api/v1/wechat-official-login/',{code:'09120kGa1CEKFB0W1HFa1gofQg220kGj'}).then((res)=>{
            console.log(res);
        })*/
    }
    toGetCode=()=>{
        let Apps={
            appid:'wxbfc11cd0650fd0e3',
            redirect_uri:encodeURIComponent('http://www.chinatd.org.cn/#/login'),///返回地址有#也会导致response_type报错
            response_type:'code',
            scope:'snsapi_userinfo', //snsapi_base用户无感觉,只能获取openId  snsapi_userinfo 弹出授权页面
            state:'true#wechat_redirect'
        };
        let href='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+Apps.appid+'&redirect_uri='+Apps.redirect_uri+'&response_type='+Apps.response_type+'&scope='+Apps.scope+'&state='+Apps.scope;
        window.location.href = href;
    };
    toreLoadWxlogin=(userType)=>{
        let baseUrl=window.location.origin;///动态获取域名
        if(IsPC()){///电脑端
            new window.WxLogin({
                self_redirect: true,
                id: 'login_container',
                appid: 'wxea5ec2ebd81fa092',
                scope: 'snsapi_login', // 写死，网页应用暂时只支持这个值
                redirect_uri: encodeURIComponent( baseUrl+`/#/success_login?userType=`+userType), // 扫码成功后重定向地址
                state: "wdawdawdawd214", // 随机字符串
                style: 'black',
                // base64加密的样式代码
                href:'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDI5OHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge3dpZHRoOiAzMDBweDt9',
            });
        }
    };
    //解决react报错：Can't perform a React state update on an unmounted component
    componentWillUnmount() {//参考链接 https://blog.csdn.net/u010565037/article/details/88716681
        this.setState = (state,callback)=>{
            return;
        };
    }
    toChangeUserType=(index)=>{
        let oldIndex=this.state.index;
        if(oldIndex!==index){
            this.setState({
                index
            });
            if(index===0){///家长
                this.toreLoadWxlogin('parent');
            }
            if(index===1){///医生
                this.toreLoadWxlogin('doctor');
            }
        }
    };
    render() {
        let systemInfo=localStorage.getItem('systemInfo')?
            JSON.parse(localStorage.getItem('systemInfo')):{};
        let footSpan='';
        if(systemInfo){
            footSpan=<span>{systemInfo.other_info}2021-{new Date().getFullYear()}<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
             <a href='https://beian.miit.gov.cn/#/Integrated/index' rel="noreferrer" target = "_blank" style={{color:'white'}}>{systemInfo.record}</a>
            </span>;
            if(!IsPC()){
                footSpan=<span style={{fontSize:'12px'}}>{systemInfo.other_info}2021-{new Date().getFullYear()}<span><br/></span>
             <a href='https://beian.miit.gov.cn/#/Integrated/index' rel="noreferrer" target = "_blank" style={{color:'white'}}>{systemInfo.record}</a>
            </span>;
            }
        }
        return (
            <div className='contents_box' style={{width:'100%',minHeight:'100%'}}>
                {IsPC()?
                    <div className='login_form_box__pc' style={this.state.index===0?style1:style2}>
                        <Card
                            style={this.state.index===0?style11:style22}
                            actions={[
                                <span className={this.state.index===0?'active':''} onClick={this.toChangeUserType.bind(this,0)}>家长登录</span>,
                                <span className={this.state.index===1?'active':''} onClick={this.toChangeUserType.bind(this,1)}>医生登录</span>,
                            ]}
                        >
                            <p className='name' style={{position:'relative',top:'10%'}}>
                            <span className='name_img'>
                                {systemInfo.site_name}
                            </span>

                            </p>
                            <div id='login_container' style={{textAlign:'center'}}/>
                        </Card>
                    </div>:''
                }
                {/*微信浏览器环境,并且是手机端*/}
                {isWeChat()&&!IsPC()&&this.state.hasUser?
                    <>  <Spin spinning={this.state.spinning} tip="登录中...">
                        <div style={{textAlign:'center',paddingTop  :'30vh'}}>
                            <button onClick={this.toGetCode.bind(this)}>微信登录授权</button>
                        </div>
                    </Spin>
                    </>:""
                }
                {!isWeChat()&&!IsPC()?
                    <>
                        <div style={{textAlign:'center',paddingTop  :'30vh',color:'white'}}>
                            <span>请在微信浏览器里或者电脑端打开</span>
                        </div>
                    </>:""
                }
                {IsPC()?
                    <p className='Copyright'>{footSpan}</p>:
                    <p className='Copyright' style={{position:'absolute',bottom:'10px',paddingTop:'40px'}}>{footSpan}</p>
                }
                {/*有账号不提示，直接跳转到首页，没有账号，页面提示*/}
                {
                    this.state.hasUser?<div>
                    </div>:<div style={{textAlign:'center',paddingTop  :'30vh',color:'white'}}>您未注册账号，请先在小程序里注册账号</div>
                }
            </div>
        );
    }
}
export default Login;